export default {
    name: 'SpotCard',
    props: {
        spotCardData: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        return props.spotCardData
    }
}
